"use client";

import { c as _c } from "react/compiler-runtime";
import GridRow from "../common/grid-row/grid-row";
import GridColumn from "../common/grid-column/grid-column";
import Link, { LinkStyle, LinkType } from "../common/link/link";
import HomeAds from "./home-ads";
import Image from "@/components/common/image/image";
import imageUrl from "@/sanity/utilities/imageUrl";
interface HeroProps {
  hero: any;
  heroHeight: number;
  variationKeyAs146: string;
  As146linkTextName?: string;
}
const AS146HeroComponent = t0 => {
  const $ = _c(48);
  const {
    hero,
    heroHeight,
    variationKeyAs146,
    As146linkTextName
  } = t0;
  let t1;
  if ($[0] !== hero.background) {
    t1 = hero.background?.asset ? `url(${imageUrl(hero.background.asset).url()})` : undefined;
    $[0] = hero.background;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `${heroHeight}px`;
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = {
      backgroundImage: t1,
      height: t2,
      minHeight: "631px"
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <HomeAds />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== hero.headline) {
    t5 = <h1>{hero.headline}</h1>;
    $[6] = hero.headline;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== hero.subhead) {
    t6 = <p className="text-xl">{hero.subhead}</p>;
    $[8] = hero.subhead;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== As146linkTextName || $[11] !== hero.options || $[12] !== variationKeyAs146) {
    t7 = hero.options?.slice(0, 2).map((option, index) => <Link key={index} href={option.cta.link.href ?? ""} linkType={LinkType.BUTTON} className="!w-full lg:!px-1 xl:!px-6">{variationKeyAs146 === "v2" && index === 0 && As146linkTextName ? As146linkTextName : option.cta.link.label}</Link>);
    $[10] = As146linkTextName;
    $[11] = hero.options;
    $[12] = variationKeyAs146;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== hero.secondaryCta) {
    t8 = hero.secondaryCta?.link && <Link href={hero.secondaryCta.link.href ?? ""} linkType={LinkType.BUTTON} linkStyle={LinkStyle.PRIMARY} className="!w-full lg:!px-1 xl:!px-6"><span>Refinance</span></Link>;
    $[14] = hero.secondaryCta;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t7 || $[17] !== t8) {
    t9 = <div className="mt-[4px] grid max-w-fit grid-cols-3 gap-4">{t7}{t8}</div>;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t5 || $[20] !== t6 || $[21] !== t9) {
    t10 = <GridRow><GridColumn lg={7}><div className="flex w-full flex-col gap-6 rounded-2xl bg-[#f2f2f2] px-14 py-10">{t4}{t5}{t6}{t9}</div></GridColumn></GridRow>;
    $[19] = t5;
    $[20] = t6;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t3) {
    t11 = <div className="!hidden min-h-[631px] items-center bg-center bg-no-repeat md:!flex" style={t3}>{t10}</div>;
    $[23] = t10;
    $[24] = t3;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== hero.background || $[27] !== hero.headline) {
    t12 = hero.background?.asset && <Image className="w-full md:!hidden" src={imageUrl(hero.background.asset).height(200).url()} alt={hero.headline ?? ""} width={609} height={200} fetchPriority="high" />;
    $[26] = hero.background;
    $[27] = hero.headline;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <HomeAds />;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== hero.headline) {
    t14 = <h1>{hero.headline}</h1>;
    $[30] = hero.headline;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== hero.subhead) {
    t15 = <h4 className="text-base !font-medium">{hero.subhead}</h4>;
    $[32] = hero.subhead;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== As146linkTextName || $[35] !== hero.options) {
    t16 = hero.options?.slice(0, 2).map((option_0, index_0) => <Link key={index_0} href={option_0.cta.link.href ?? ""} linkType={LinkType.BUTTON} className="!w-full border-2 border-solid border-[#00698F]">{index_0 === 0 && As146linkTextName ? As146linkTextName : option_0.cta.link.label}</Link>);
    $[34] = As146linkTextName;
    $[35] = hero.options;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== hero.secondaryCta) {
    t17 = hero.secondaryCta?.link && <Link href={hero.secondaryCta.link.href ?? ""} linkType={LinkType.BUTTON} linkStyle={LinkStyle.PRIMARY} className="!w-full border-2 border-solid border-[#00698F]"><span>Refinance</span></Link>;
    $[37] = hero.secondaryCta;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t14 || $[40] !== t15 || $[41] !== t16 || $[42] !== t17) {
    t18 = <GridRow className="grid md:!hidden"><GridColumn><div className="flex flex-col gap-6 py-10">{t13}{t14}{t15}{t16}{t17}</div></GridColumn></GridRow>;
    $[39] = t14;
    $[40] = t15;
    $[41] = t16;
    $[42] = t17;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== t11 || $[45] !== t12 || $[46] !== t18) {
    t19 = <>{t11}{t12}{t18}</>;
    $[44] = t11;
    $[45] = t12;
    $[46] = t18;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  return t19;
};
export default AS146HeroComponent;